// Signing out clears this browser's saved session — tokens, the cached user —
// but keeps two things that belong to the browser rather than the session:
// the display settings (light / dark theme and layout) and the restaurant
// branding the login page shows. Without this the login page after a sign-out
// always came back in the light theme with the YouSlotz logo.
const KEEP_KEYS = ['datta-able-react-ts-config', 'yz-branding'];

export default function clearSession() {
  try {
    const kept = KEEP_KEYS.map((key) => [key, localStorage.getItem(key)]);
    localStorage.clear();
    kept.forEach(([key, value]) => {
      if (value !== null) localStorage.setItem(key, value);
    });
  } catch {
    // Storage blocked: nothing was kept to clear.
  }
}
